<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
      class="edit-timesheet-modal"
      :destroyOnClose="true"
    >
      <ValidationObserver
        ref="formAdditionalTimeSheet"
        v-slot="{ handleSubmit }"
      >
        <CForm
          class="create_form"
          @submit.prevent="handleSubmit(createTimesheetRequest)"
        >
          <CRow>
            <CCol md="12" class="form-field">
              <label>
                {{ $t("fields.additional_timeSheet.request_date") }}
                <span class="require">*</span>
              </label>
              <div>
                <a-date-picker
                  class="form-field-date-picker"
                  :disabled-date="disabledDate"
                  v-model="dateWork"
                  format="DD/MM/YYYY"
                  disabled
                />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("fields.additional_timeSheet.admin") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="additional_timeSheet.admin"
              >
                <select class="form-control" v-model="forms.admin_id">
                  <option
                    v-for="(option, index) in dataCreateForm.admin"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
            <CCol md="6" class="form-field mobile-input">
              <label>
                {{ $t("fields.additional_timeSheet.manager") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="additional_timeSheet.manager"
              >
                <select class="form-control" v-model="forms.manager_id">
                  <option
                    v-for="(option, index) in dataCreateForm.manager"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow>
            <CCol md="6" class="form-field">
              <label>{{
                $t("fields.additional_timeSheet.check_in_real")
              }}</label>
              <div class="form-control bg-text">
                {{ forms.start_time_real | formatHour }}
              </div>
            </CCol>
            <CCol md="6" class="form-field mobile-input">
              <label>
                {{ $t("fields.additional_timeSheet.check_in_request") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="additional_timeSheet.check_in_request"
              >
                <b-form-input
                  type="text"
                  v-model="forms.start_time_request"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow>
            <CCol md="6" class="form-field">
              <label>{{
                $t("fields.additional_timeSheet.check_out_real")
              }}</label>
              <div class="form-control bg-text">
                {{ forms.end_time_real | formatHour }}
              </div>
            </CCol>
            <CCol md="6" class="form-field mobile-input">
              <label>
                {{ $t("fields.additional_timeSheet.check_out_request") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="additional_timeSheet.check_out_request"
              >
                <b-form-input
                  type="text"
                  v-model="forms.end_time_request"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="12" class="form-field">
              <label>{{ $t("fields.additional_timeSheet.evidence") }}</label>
              <span class="require"> *</span><br />
              <a-upload
                :file-list="fileList"
                :multiple="true"
                list-type="picture"
                @preview="handlePreview"
                :beforeUpload="beforeImageUpload"
                @change="handeImageChange"
              >
                <a-button class="btn-ecs-upload">
                  <img src="../../../assets/icons/file.svg" alt="" />
                  Chọn ảnh
                </a-button>
                <br /><span class="require">{{ uploadImageMessage }}</span>
              </a-upload>
              <a-modal
                :zIndex="1030"
                centered
                class="preview-image"
                :visible="previewVisible"
                :footer="null"
                @cancel="handleCancelPreview"
              >
                <img alt="preview" style="width: 100%" :src="previewImage" />
              </a-modal>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="12" class="form-field">
              <label>
                {{ $t("fields.additional_timeSheet.edit_reason") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|max:512"
                v-slot="{ errors }"
                name="additional_timeSheet.edit_reason"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="forms.reason"
                  rows="5"
                  max-rows="6"
                  maxlength="255"
                ></b-form-textarea>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="12" class="form-data">
              <CButton type="submit" class="save-info footer-btn">
                {{ $t("commons.admin_approve") }}
              </CButton>
              <CButton
                class="cancel-btn footer-btn"
                type="button"
                @click="showConfirm"
                >{{ $t("commons.cancel_modal") }}</CButton
              >
            </CCol>
          </CRow>
        </CForm>
      </ValidationObserver>
    </a-modal>
    <CusModal
      @handleCancel="hideConfirm"
      @handleOk="confirmRequest"
      :title="
        $t('popup.commons.label_popup_confirm_cancel_add_timesheet_modal')
      "
      :isShow="isShowConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
    <CusModal
      @handleCancel="hideErrorConfirm"
      @handleOk="hideErrorConfirm"
      :title="$t('popup.commons.label_popup_error')"
      :showCancelBtn="false"
      :isShow="isShowError"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_error_empty_manager") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CusModal from "@/components/commons/CusModal.vue";

// import DatePickerSelectTimeSheet from "@/components/commons/DatePickerSelectTimeSheet";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
    // DatePickerSelectTimeSheet,
  },
  computed: {
    ...mapGetters({
      projectsEmployees: "overtime-request/projectsEmployees",
      approvalPersons: "overtime-request/approvalPersons",
      dataCreateForm: "additional-timesheet/dataCommonAdditionalTimeSheet",
    }),
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.fileList = [];
      }
    },
  },
  data() {
    return {
      dateWork: "",
      title: this.$t("dashboard.modal.edit_timesheet"),
      visible: false,
      isShowConfirm: false,
      isShowError: false,
      errorFileMessage: "",
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG",
      ],
      fileList: [],
      uploadImageMessage: "",
      isImage: true,
      image_evidence: "",
      forms: {
        work_date: null,
        admin_id: "",
        start_time_real: "",
        end_time_real: "",
        end_time_request: "",
        start_time_request: "",
        reason: null,
        img_evidence: "",
      },
      previewVisible: false,
      previewImage: "",
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    moment,
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    disabledDate(current) {
      return (
        current < moment(this.forms.work_date).startOf("month") ||
        moment(current).isSameOrAfter(moment(), "day")
      );
    },

    hideErrorConfirm() {
      this.isShowError = false;
    },

    async showModal(date) {
      this.forms.admin_id = "";
      this.forms.start_time_real = "";
      this.forms.end_time_real = "";
      this.forms.end_time_request = "";
      this.forms.start_time_request = "";
      this.dateWork = moment(date, "DD/MM/YYYY") ?? null;
      this.forms.img_evidence = "";
      this.forms.reason = null;

      const validate = this.$refs.formAdditionalTimeSheet;
      if (typeof validate !== "undefined") {
        this.$refs.formAdditionalTimeSheet.reset();
      }
      this.$root.$loading.start();

      await this.$store.dispatch(
        "additional-timesheet/commonAdditionalTimeSheet",
        {
          work_date: moment(this.dateWork, "DD/MM/YYYY").format("DD/MM/YYYY"),
        }
      );
      if (
        this.dataCreateForm.manager.length === 0 ||
        this.dataCreateForm.admin.length === 0
      ) {
        this.isShowError = true;
        this.$root.$loading.finish();
        return;
      }
      this.visible = true;
      let start_time_real =
        this.dataCreateForm.timeSheet !== null
          ? this.dataCreateForm.timeSheet.start_time_real
          : "";
      let end_time_real =
        this.dataCreateForm.timeSheet !== null
          ? this.dataCreateForm.timeSheet.end_time_real
          : "";
      this.forms.start_time_real =
        start_time_real !== null ? start_time_real : "";
      this.forms.end_time_real = end_time_real !== null ? end_time_real : "";
      // this.forms.start_time_request =
      //   this.forms.start_time_real <= this.forms.start_time_request &&
      //   this.forms.start_time_real != ""
      //     ? this.forms.start_time_real
      //     : this.forms.start_time_request;
      // this.forms.end_time_request =
      //   this.forms.end_time_real >= this.forms.end_time_request &&
      //   this.forms.end_time_real != ""
      //     ? this.forms.end_time_real
      //     : this.forms.end_time_request;
      this.forms.start_time_request = this.forms.start_time_real || "08:00";
      this.forms.end_time_request = this.forms.end_time_real || "17:30";

      let keyRandom = Math.floor(
        Math.random() * this.dataCreateForm.admin.length
      );
      this.forms.admin_id = this.dataCreateForm.admin[keyRandom]?.id;
      this.forms.manager_id = this.dataCreateForm.manager[keyRandom]?.id;
      this.$root.$loading.finish();
    },
    hideModal() {
      this.visible = false;
    },
    hideConfirm() {
      this.isShowConfirm = false;
    },
    showConfirm() {
      this.isShowConfirm = true;
    },
    confirmRequest() {
      this.hideConfirm();
      this.hideModal();
    },
    async createTimesheetRequest() {
      if (this.fileList.length == 0) {
        this.uploadImageMessage =
          this.$t("additional_timeSheet.evidence") +
          " " +
          this.$t("error.require");
        return false;
      }
      this.forms.work_date = this.dateWork.format("DD/MM/YYYY");
      this.$root.$loading.start();
      let formData = new FormData();
      for (let key in this.forms) {
        if (key === "img_evidence") {
          if (this.fileList.length > 0) {
            this.fileList.forEach((file) => {
              formData.append("img_evidence[]", file.originFileObj);
            });
          }
        } else {
          formData.append(key, this.forms[key]);
        }
      }

      await this.$store
        .dispatch("additional-timesheet/registerAdditionalTimeSheet", formData)
        .then(() => {
          let message = this.$t("popup.timesheet.label_popup_update_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("fetchData");
          this.$emit("fetchToTalDataDashBoard");
          this.$store.dispatch("commons/getCountRequest");
          this.visible = false;
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
          // let message = this.$t("popup.timesheet.label_popup_update_fail");
          // this.$toast(message, null, 2000, "b-toaster-top-center", "danger");
          // this.$emit("fetchData");
          // this.visible = false;
        });
    },

    cancel() {
      this.hideModal();
    },

    handeImageChange(info) {
      this.uploadImageMessage = "";
      if (info.fileList.length > 2) {
        this.uploadImageMessage = "Upload tối đa 2 ảnh";
        return;
      }
      this.fileList = [];
      info.fileList.forEach((fileInfo) => {
        if (fileInfo.size > 2000000) {
          this.uploadImageMessage = this.$t("error.img_max");
          return;
        }
        if (this.imageType.includes(fileInfo.type)) {
          this.fileList.push(fileInfo);
        } else {
          this.uploadImageMessage = "Chỉ hỗ trợ định dạng .png, .jpg, .jpeg";
          return;
        }
      });
    },
    beforeImageUpload() {
      return false;
    },
  },
};
</script>


<style lang="scss">
@media screen and (max-width: 320px) {
  .date-pk span.required {
    font-size: 11.2px;
  }
}
.btn-ecs-upload {
  background: #f8f8f8;
  border: 1px solid #ededed;
  border-radius: 20px;

  & > img {
    margin-right: 10px;
  }
}
.edit-timesheet-modal {
  .ant-modal-mask,
  .ant-modal-wrap {
    z-index: 1030;
  }
  .ant-modal {
    width: 100% !important;
    max-width: 684px;
  }
  .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-modal-header {
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-modal-title {
      color: #3d4cdc;
    }
  }
  .ant-modal-close {
    outline: unset !important;
  }

  .ant-modal-close-x {
    line-height: 48px;
    outline: unset !important;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 740px) {
  .save-info {
    margin-right: 0 !important;
    padding: 7px !important;
    width: 100%;
  }
  .cancel-btn {
    background-color: #ececec;
    color: #6f6f6f;
  }
  .mobile-input {
    margin-top: 20px;
  }
  .form-data {
    margin-top: 20px;
  }
  .padding-mobile {
    padding: 0 !important;
  }
  .mobile-header {
    margin-bottom: 0;
  }
}
.form-control-file {
  overflow: hidden;
}
.save-info {
  margin-right: 10px;
  background-color: #3d4cdc;
  color: #fff;
}
.footer-btn {
  border-radius: 10px;
  width: 210px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
}

label {
  font-weight: 600;
}

.input-group {
  margin-bottom: 0px !important;
}

.row {
  margin-bottom: 20px;
}

.cancel-btn {
  padding: 7px 45px;
  font-weight: 600;
  background: #f6f6f6;
  color: #0d2e48;
}

span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}

.form-data {
  text-align: center;
}
.image-evidence {
  max-width: 90%;
}
p.note {
  font-weight: 700;
  color: #ff1a1a;
}
.form-field-date-picker {
  width: 100%;
  /deep/.ant-input:focus {
    border-color: #958bef;
  }
  /deep/ .ant-input:hover {
    border-color: #958bef;
  }
}
.edit-timesheet-modal {
  /deep/.ant-modal-close:focus {
    outline: none;
  }
}
.warning-title {
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #303c54;
  img {
    margin-right: 10px;
  }
}
.modal-content {
  border: none;
}
</style>
